import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledGainAccessContainer = styled.div`
    display: flex;
    background-color: ${colorsPalettes.carbon[0]};
    padding: 24px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 24px;
    border-radius: 6px;
`;

export const StyledGainAccessTitle = styled.div`
    display: flex;
    margin-top: 24px;
    ${setFontVariant("subtitle1", colorsPalettes.carbon[500])};
`;

export const StyledGainAccessSubTitle = styled.div`
    display: flex;
    max-width: 360px;
    margin-top: 8px;
    text-align: center;
    ${setFontVariant("caption", colorsPalettes.carbon[300])};
`;

export const StyledGainAccessBtnWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`;
